import { handleize } from '../../../../scripts/utils/helpers';
import React from 'react';
import { L1Item } from './NAV_TYPES';
import { handleHeapTracking } from './menu-item';
import { fireGA4MenuClickEvent } from 'src/scripts/utils/gtm-data-layer';

type SubMenuProps = {
  link: L1Item;
  isActive: boolean;
};

function SubMenu({ link, isActive }: SubMenuProps) {
  const linkTitleHandle = handleize(link.title);
  const linkSize = link.items?.length || 0;
  const otherColumnSize = linkSize * 2;
  const giftItemColumnSize = 12 - otherColumnSize;

  return (
    <div
      id={`${linkTitleHandle}SubItem`}
      className={`container-fluid main-navbar__sub-items navOpenOnHoverChild ${linkTitleHandle} ${
        isActive ? 'fade-in' : 'fade-out'
      }`}
      style={{ zIndex: 1000 }}
      role="list"
    >
      <div className="row no-gutters main-navbar__sub-items__row" role="listitem">
        {link.items?.map((subLink) => {
          const subLinkTitleHandle = handleize(subLink.title);
          return (
            <div key={subLinkTitleHandle} className="main-navbar__sub-item__column col-2" role="list">
              {subLink.url ? (
                <a
                  href={subLink.url}
                  className="d-block main-navbar__sub-item clickable"
                  data-nav={`${linkTitleHandle}-->${subLinkTitleHandle}`}
                  onClick={(e) => {
                    handleHeapTracking(e);
                    fireGA4MenuClickEvent(subLink.title, link.title);
                  }}
                  style={{
                    color: subLink?.color,
                  }}
                >
                  {subLink.title}
                </a>
              ) : (
                <span
                  className="d-block main-navbar__sub-item clickable"
                  style={{
                    color: subLink?.color,
                  }}
                >
                  {subLink.title}
                </span>
              )}
              <ul className="d-flex flex-column ml-0">
                {subLink.items.map((subSubLink) => {
                  const subSubLinkTitleHandle = handleize(subSubLink.title);
                  return (
                    <li key={subSubLinkTitleHandle} className={`main-navbar__sub-sub-item`}>
                      <a
                        href={subSubLink.url}
                        style={{
                          color: subSubLink.color,
                          paddingTop: subSubLink.paddingTop,
                          display: 'block',
                          fontWeight: subSubLink.fontWeight,
                        }}
                        data-nav={`${linkTitleHandle}-->${subLinkTitleHandle}-->${subSubLinkTitleHandle}`}
                        onClick={(e) => {
                          handleHeapTracking(e);
                          fireGA4MenuClickEvent(subSubLink.title, link.title, subLink.title);
                        }}
                      >
                        {subSubLink.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
        {link.imageBlocks && (
          <div className={`col-${giftItemColumnSize} sub-item--gift-layout`}>
            <div className="row">
              {link.imageBlocks?.map((imageBlock, index) => (
                <div key={index} className="col-3 sub-item__column--gift-layout">
                  <a
                    href={imageBlock.url}
                    className="gift-layout__image--wrapper"
                    onClick={() => {
                      fireGA4MenuClickEvent(imageBlock.title, link.title);
                    }}
                  >
                    <img
                      src={imageBlock.image}
                      alt={imageBlock.altText}
                      style={{ maxWidth: '300px', maxHeight: '300px' }}
                    />
                  </a>
                  <a
                    href={imageBlock.url}
                    className="gift-layout__sub-sub-title"
                    onClick={() => {
                      fireGA4MenuClickEvent(imageBlock.title, link.title);
                    }}
                  >
                    {imageBlock.title}
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubMenu;
